import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Bottomright from "../../../assets/images/first-page/bottom-right-gradient.svg";
import Topleft from "../../../assets/images/first-page/top-left-gradient.svg";
import {
  Typography,
  Box,
  Stack,
  Button
} from "@mui/material";
import Logo from "../../../assets/images/common/logo.png";
import { useTheme } from '@mui/material/styles';

import { KeyboardBackspaceOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";

const Terms = () => {
  const theme = useTheme();

  return (
    <>
      <Box
        className="welcome-page"
        sx={{ position: "relative", zIndex: "9999" }}
      >
        <Container className="cabinetfont">

          <Box display="flex" justifyContent="flex-start">

            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<KeyboardBackspaceOutlined />}
              sx={{
                width: "120px",
                height: "50px",
                backgroundColor: "primary.main",
                fontSize: "18px",
                fontWeight: "500",
                borderRadius: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 0px",
              }}
              component={Link}
              to="/login"
            >

            </Button>
          </Box>

          <Stack
            direction={"column"}
            justifyContent={"start"}
            alignItems={"start"}
            marginLeft={"14%"}
          >
            <Box>
              <img src={Logo} alt="logo" />
            </Box>

            <Box sx={{ width: { xs: '100%', md: "80%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "500" }}
                fullWidth
              >
                Imagnce Pty Ltd for the use of the App ASKLMS
              </Typography>
            </Box>
            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>

              <Typography
                variant="body1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: "30px",
                  fontWeight: "500",
                  mt: { xs: "16px", xl: "12px" },
                  mb: { xs: "12px", xl: "28px" },
                }}
              >
                Terms of Use
              </Typography>
            </Box>

            <Box sx={{ width: "100%", paddingTop: { xs: "10px", xl: "20px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "24px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                Thank you for using the ASKLMS App.
              </Typography>

            </Box>

            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "3px", xl: "6px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                These Terms of Use apply to your use of the ASKLMS App, other services for individuals, along with any associated software applications and websites (all together, “Services”). These Terms form an agreement between you and ASKLMS and Imagnce Pty Ltd, a company registered in Australia. The terms include our Service Terms and important provisions for resolving disputes through arbitration. By using our Services, you agree to these Terms.
              </Typography>


            </Box>
            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Who We Are
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                ASKLMS is an App developed and owned by Imagnce Pty Ltd, an App company registered in Australia. The ASKLMS App provides a convenient way to ask various AI models the same prompt or question and allows the user to evaluate these and choose their preferred response.               </Typography>

            </Box>
            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Registration and Access
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "400",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                <b>Minimum Age:</b> You must be at least 13 years old or the minimum age required in your country to consent to use the Services. If you are under 18, you must have your parent or legal guardian’s permission.
              </Typography>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "400",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                <b>Registration: </b>You must provide accurate and complete information to register for an account. You are responsible for all activities that occur under your account.


              </Typography>



            </Box>
            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Use our Services
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "400",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                <b>What You Can Do:</b> You may access and use our Services in compliance with applicable laws and policies.


              </Typography>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                <b>What You Cannot Do:</b> You may not use our Services for any illegal, harmful, or abusive activity, including but not limited to:




              </Typography>
              <Box component="ul" sx={{ pl: 3, color: "#CBD2E2" }}>
                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                  Infringing, misappropriating, or violating anyone’s rights.
                </Typography>
                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                  Modifying, copying, leasing, selling, or distributing our Services
                </Typography>
                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                  Reverse engineering or discovering the source code.
                </Typography>
                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                  Automatically extracting data or Output.
                </Typography>
                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                  Interfering with or disrupting our Services.
                </Typography>
              </Box>

            </Box>

            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Content
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                You may provide input to the Services (“Input”), and receive output (“Output”). You are responsible for Content and ensuring it does not violate any applicable law or these Terms.
              </Typography>


            </Box>
            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Ownership of Content
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                You retain ownership of your Input and Output. However, due to the nature of AI, Output may not be unique.

              </Typography>


            </Box>
            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Wallet and Paid Accounts
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                ASKLMS provides free credits. Once your balance is low, a charge will be made to your account. Payments are non-refundable except where required by law.

              </Typography>


            </Box>
            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Termination and Suspension
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                We reserve the right to suspend or terminate your access if:
              </Typography>

              <Box component="ul" sx={{ pl: 3, color: "#CBD2E2" }}>
                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                  You breach these Terms.
                </Typography>
                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                  Required by law.
                </Typography>
                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                  Your use poses risk to ASKLMS or third-party services.
                </Typography>
              </Box>
            </Box>

            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Disclaimer of Warranties
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                Our Services are provided “as is.” We make no warranties regarding the accuracy, reliability, or uninterrupted availability of our Services.


              </Typography>


            </Box>
            <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                fullWidth
              >
                Limitation of Liability
              </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#CBD2E2",
                  fontSize: { xs: '15px', md: "20px" },
                  fontWeight: "500",
                  mb: { xs: "14px", xl: "24px" },
                }}
                fullWidth
              >
                We are not liable for any indirect, incidental, or special damages, including loss of profits, goodwill, or data.

              </Typography>


            </Box>
          </Stack>
        </Container>

        <Box sx={{
          position: "absolute", top: 0, left: 0, zIndex: "-1", "& > .child": {
            width: { xs: '300px', md: 'auto' },
          },
        }}>
          <img src={Topleft} alt="gradient" className="child" />
        </Box>
        <Box sx={{
          position: "absolute", bottom: 0, right: 0, zIndex: "-1", "& > .child": {
            width: { xs: '300px', md: 'auto' },
          },
        }}>
          <img src={Bottomright} alt="gradient" className="child" />
        </Box>

      </Box>
    </>
  );
}

export default Terms